module.exports = __webpack_public_path__ + "img/empty.76f9c7df.png";